import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../services/analytics';

// This component will initialize GA and track page views
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  // Initialize GA once when component mounts
  useEffect(() => {
    initGA();
  }, []);

  // Track page view whenever location changes
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker;
